import { gql } from '@apollo/client';
import { MaterialPostType } from '../../config/types';

type CompanySpaceTab =
	| 'info'
	| 'products'
	| 'integrators'
	| 'products_supported'
	| 'services'
	| 'posts'
	| 'content'
	| 'events'
	| 'job_postings';

export interface View {
	target: 'vendor' | 'post' | 'interview';
	company_id: string;
	company_name: string;
	company_logo?: string;
	company_space_tab?: CompanySpaceTab;
	post_type?: 'post' | 'product' | 'service' | MaterialPostType;
	post_subtype?: string;
	post_id?: string;
	post_title?: string;
	post_slug?: string;
	user_id?: string;
	user_name?: string;
	user_avatar?: string;
	user_company_id?: string;
	user_company_name?: string;
	user_role?: 'vendor' | 'member';
}

export const CREATE_VIEW = gql(`
    mutation createView(
        $target: String!, $company_id: String!, $company_name: String!, $company_logo: String = "", 
        $company_space_tab: String = "", $user_role: String = "", $user_name: String = "", $user_id: String = "", 
        $user_company_name: String = "", $user_company_id: String = "", $user_avatar: String = "", 
        $post_title: String = "", $post_slug: String = "", $post_type: String = "", $post_subtype: String = "", 
        $post_id: String = ""
    ) {
        insert_views(
            objects: {
                company_id: $company_id, company_logo: $company_logo, company_name: $company_name, 
                company_space_tab: $company_space_tab, post_id: $post_id, post_subtype: $post_subtype, 
                post_title: $post_title, post_slug: $post_slug, post_type: $post_type, target: $target, 
                user_id: $user_id, user_name: $user_name, user_role: $user_role, user_avatar: $user_avatar, 
                user_company_id: $user_company_id, user_company_name: $user_company_name
            }
        ) {
            returning {
                id
            }
        }
    }
`);

export const CREATE_FILTER_TRACKING = gql(`
	mutation CreateFilterTracking(
        $category: String = "", $company_logo: String = "", $company_name: String = "", $filter_type: String!, 
        $filter_value: String!, $path: String!, $tag: String = "", $user_avatar: String = "", 
        $user_company_id: String = "", $user_company_name: String = "", $user_id: String = "", $user_name: String = "", 
        $user_role: String!	
    ) {
		insert_filters_tracking(
			objects: {
                category: $category, company_logo: $company_logo, company_name: $company_name, 
                filter_type: $filter_type, filter_value: $filter_value, path: $path, tag: $tag, 
                user_avatar: $user_avatar, user_company_id: $user_company_id, user_company_name: $user_company_name, 
                user_id: $user_id, user_name: $user_name, user_role: $user_role 
			}
		) {
			returning {
				id
			}
		}
	}
`);

export const CREATE_CLICK_TRACKING = gql(`
	mutation createClickTracking(
		$post_company_id: String!, $post_company_name: String!, $reference_label: String!, $reference_type: String!, 
		$reference_value: String!, $referer_component: String!, $referer_path: String!, $user_id: String!, 
		$user_role: String!
	) {
		insert_click_tracking_one(
			object: {
				post_company_id: $post_company_id, post_company_name: $post_company_name, reference_label: $reference_label, 
				reference_type: $reference_type, reference_value: $reference_value, referer_component: $referer_component, 
				referer_path: $referer_path, user_id: $user_id, user_role: $user_role
			}
		) {
			id
		}
	}
`);
